let observers = [];

const publish = ({ key, newValue }) => {
  observers.forEach(element => {
    element.observer(key, newValue);
  });
}

window.onstorage = ({ key, newValue }) => {
  publish({ key, newValue });
}

export default {
  subscribe(observer) {
    const id = crypto.randomUUID();
    observers.push({ id, observer });
    return id;
  },
  unsubscribe(observer) {
    observers = observers.filter((obs) => obs.id !== observer);
  },
  escreveStorage(chave, valor) {
    localStorage.setItem(chave, valor);

    publish({ key: chave, newValue: valor });
  },
  lerStorage(chave) {
    return localStorage.getItem(chave);
  },
  removeItem(chave) {
    localStorage.removeItem(chave);

    publish({ key: chave, newValue: null });
  },
  clear() {
    localStorage.clear();
  },
};
